import BookingsRoutes from "./bookings.js";
import LocationRoutes from "./locations";
import DomainRoutes from "./domains";
import SettingsRoutes from "./settings";
import paymentsRoutes from "./payments";
import AnalyticRoutes from "./analytic"

export default [
  {
    path: "/dashboard",
    name: "UserDashboard",
    component: () => import("@/views/Ondemand/Dashboard.vue"),
  },
  ...BookingsRoutes,
  ...DomainRoutes,
  ...LocationRoutes,
  ...SettingsRoutes,
  ...paymentsRoutes,
  ...AnalyticRoutes
];
